<template>
    <OverlayLoader :isLoading="!webshopsLoaded || !accountInfoLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('general.webshops')"
                />

                <WhiteTable :labels="[$translate.text('general.name'), $translate.text('general.webshop_type')]">
                    <template slot="table-data">
                        <tr v-for="webshop in webshops" :key="webshop.id">
                            <td>{{ webshop.name }}</td>
                            <td>{{ webshop.type_label }}</td>
                            <td class="align-right">
                                <i v-if="accountInfo.subscribed_till !== null" class="fal fa-edit" @click="$router.push({ name: 'Clients Webshops Edit', params: { id: webshop.id } })" v-tooltip.bottom="$translate.text('tooltip.edit')"></i>
                                <i class="fal fa-trash-alt" @click="deleteWebshop(webshop.id)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                            </td>
                        </tr>
                        <tr v-if="!webshops.length">
                            <td colspan="3">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
            </div>

            <FloatingButton
                v-if="accountInfo.subscribed_till !== null || webshops.length === 0"
                @clicked="$router.push({ name: 'Clients Webshops Add' })"
            />
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';
import { get, remove } from '@/helpers/http';
import handleError from '@/helpers/error';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import FloatingButton from '@/components/FloatingButton/FloatingButton';
import { getUser } from '@/helpers/auth';

export default {
    name: 'ClientsWebshops',

    components: {
        PageHeader,
        OverlayLoader,
        WhiteTable,
        FloatingButton,
    },

    data() {
        return {
            accountInfo: {},
            accountInfoLoaded: false,

            webshops: [],
            webshopsLoaded: false,
        };
    },

    created() {
        this.getAccountInfo();
        this.getWebshops();
    },

    methods: {
        getAccountInfo() {
            const user = getUser();
            this.accountInfo = user.client.subscription;
            this.accountInfoLoaded = true;
        },

        getWebshops() {
            get({
                url: `${this.$API_URL}/api/clients/webshops`,
            })
                .then((response) => {
                    this.webshops = response.data.data;
                    this.webshopsLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        deleteWebshop(id) {
            swal(
                this.$translate.text('alert.confirm.delete'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    remove({
                        url: `${this.$API_URL}/api/clients/webshops/${id}`,
                    })
                        .then(() => {
                            this.getWebshops();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },
    },
};
</script>
